import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { CustomAlert, CustomButton, CustomCheckBox, Text } from '../../../shared/uiComponents';
import { AdminTypes } from '../../../components/Menu';

import { useSelector } from '../../../redux/store';

const ForcedOperation = ({ submit }: { submit: () => void }) => {
	const [errorList, setErrorList] = useState<string[]>([]);
	const [params, setParams] = useSearchParams();
	const error = useSelector((state) => state.soapNote.error);
	const role = useSelector((state) => state.account.role);

	const onClose = () => {
		params.delete('forcedOperation');
		setParams(params, { replace: true });
		setErrorList([]);
	};

	useEffect(() => {
		if (!error?.errors) return;
		const errorLisValues = Object.values(error.errors) as string[];
		setErrorList(errorLisValues);
	}, [error]);

	return (
		<CustomAlert
			open={errorList.length > 0 && AdminTypes.admin === role?.section.id}
			onClose={onClose}
			title="Are you sure?"
			Content={() => (
				<div>
					{errorList.map((x) => (
						<Text title={x} type="psm" fontWeight="semiBold" className="marginBottom8" key={x} />
					))}
					<CustomCheckBox
						item={{
							id: '0',
							label: 'Ignore required fields',
							checked: params.get('forcedOperation') === 'true',
						}}
						onChange={(event) => {
							const { checked } = event.target;
							params.set('forcedOperation', `${checked}`);
							setParams(params, { replace: true });
						}}
						style={{ marginBottom: '16px' }}
					/>
					<CustomButton
						title="Confirm"
						onClick={submit}
						disabled={params.get('forcedOperation') !== 'true'}
						className="marginBottom16"
					/>
					<CustomButton title="Cancel" onClick={onClose} buttonType="secondaryGray" />
				</div>
			)}
		/>
	);
};

export default ForcedOperation;
